import { ReactComponent as HamburgerIcon } from '@assets/icons/hamburger.svg';
import { ReactComponent as DelphiaWordMark } from '@assets/logos/delphia-wordmark.svg';
import { Link, Logo, NavLink, ScreenReaderLabel } from '@components/core';
import MobileMenuContext from '@contexts/mobile_menu_context';
import { media } from '@helpers/media_templates';
import { pageList } from '@helpers/pages';
import React from 'react';
import styled from 'styled-components';

const LOGO_BREAK_POINT = 900;

const Nav = styled.nav`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  padding: 20px;

  ${media.medium`
    padding: 39px 60px;
  `}

  ${media.large`
    padding: 39px 100px;
  `}
`;

const NavMenu = styled.ul`
  display: flex;
  padding: 0;
  margin: 0;
  list-style: none;
  align-items: center;

  ${media.large`
    justify-content: flex-start;
  `}
`;

const NavItem = ({ className, to, children }) => (
  <li className={className}>
    <NavLink to={to}>{children}</NavLink>
  </li>
);

const DesktopNavItem = styled(NavItem)`
  display: none;
  margin-right: 30px;

  &:last-child {
    margin-right: 0;
  }

  ${media.medium`
      display: inline-block;
  `}

  ${media.large`
    margin-right: 42px;
  `}
`;

const NavDelphiaWordMarkItem = styled.li`
  margin-right: 30px;
  height: 32px;

  ${media.large`
    margin-right: 42px;
  `}
`;

const DelphiaLogo = styled(Logo)`
  display: none;

  ${media.customBreak(LOGO_BREAK_POINT)`
    display: inline-block;
  `}
`;

const MiddleLogoContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const Hamburger = styled.button`
  width: 40px;
  height: 40px;
  display: inline-block;
  background: none;
  padding: 0;
  padding: 8px;

  border: none;
  outline: none;

  svg {
    fill: ${props => props.theme.nav.iconColor};
    height: 24px;
    width: 24px;
  }

  :hover {
    background: rgba(0, 0, 0, 0.2);
  }
`;

const MobileMenuToggleWrapper = styled.div`
  display: flex;
  height: 48px;
  width: 48px;
  justify-content: center;
  align-items: center;

  ${media.medium`
      display: none;
  `}
`;

const MobileMenuJoinLinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const MobileMenuToggle = ({ toggleOpen }) => (
  <MobileMenuToggleWrapper>
    <Hamburger aria-label="Open menu" onClick={toggleOpen}>
      <HamburgerIcon alt="Open Menu" />
    </Hamburger>
  </MobileMenuToggleWrapper>
);

const Header = ({ location }) => {
  return (
    <Nav>
      <NavMenu>
        <NavDelphiaWordMarkItem>
          <Link to="/">
            <DelphiaWordMark />
            <ScreenReaderLabel>Home Page</ScreenReaderLabel>
          </Link>
        </NavDelphiaWordMarkItem>
        {pageList.map(({ id, to, text }) => {
          return (
            <DesktopNavItem key={id} to={to}>
              {text}
            </DesktopNavItem>
          );
        })}
      </NavMenu>
      <MiddleLogoContainer>
        <Link to="/">
          <DelphiaLogo />
          <ScreenReaderLabel>Home Page</ScreenReaderLabel>
        </Link>
      </MiddleLogoContainer>
      <MobileMenuJoinLinkContainer>
        <MobileMenuContext.Consumer>{MobileMenuToggle}</MobileMenuContext.Consumer>
      </MobileMenuJoinLinkContainer>
    </Nav>
  );
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
